import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { PreviewSection } from './components/PreviewSection';
import { IncludedSection } from './components/IncludedSection';
import { ChaptersSection } from './components/ChaptersSection';
import { VisualTypesSection } from './components/VisualTypesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { Footer } from './components/Footer';
import { PurchaseAlert } from './components/PurchaseAlert';
export function App() {
  return <div className="min-h-screen w-full bg-night font-body text-cream" data-id="element-0" data-mp="2wip7v6vrtq71">
      <Hero data-id="element-1" data-mp="28te4dhn1dhp7" />
      <main data-id="element-2" data-mp="28sutgkvsztko">
        <ProblemSection data-id="element-3" data-mp="28skzynbjv4a8" />
        <PreviewSection data-id="element-4" data-mp="23vchsmqej08z" />
        <IncludedSection data-id="element-5" data-mp="23w4gi6fape3h" />
        <ChaptersSection data-id="element-6" data-mp="23utcc5hxu4bu" />
        <VisualTypesSection data-id="element-7" data-mp="23t8ea5wf0398" />
        <TestimonialsSection data-id="element-8" data-mp="3ik7jmqgv0tve" />
        <OfferSection data-id="element-9" data-mp="3ij64oawq3n8e" />
        <GuaranteeSection data-id="element-10" data-mp="3ijpe138b53at" />
        <FaqSection data-id="element-11" data-mp="3mlj82snzz920" />
      </main>
      <Footer data-id="element-12" data-mp="3mkhlps1j704z" />
      <PurchaseAlert data-id="element-13" data-mp="3mk84otygs3bf" />
    </div>;
}